import { render, staticRenderFns } from "./RatingModal.vue?vue&type=template&id=02b39847&scoped=true"
import script from "./RatingModal.vue?vue&type=script&lang=js"
export * from "./RatingModal.vue?vue&type=script&lang=js"
import style0 from "./RatingModal.vue?vue&type=style&index=0&id=02b39847&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b39847",
  null
  
)

export default component.exports